export const CoverCompositionCRM = Object.freeze({
  SINGLE: 'Single person',
  COUPLE: 'Couple',
  FAMILY: 'Family',
  SINGLE_PARENT: 'Single parent family',
  CHILDREN_ONLY: 'Child/Children only',
  FAMILY_PLUS: 'Family plus',
  SINGLE_PARENT_PLUS: 'Single parent plus',
});

export const CoverCompositionCRMCodeMapping = [
  { code: '1', value: 'single' },
  { code: '2', value: 'couple' },
  { code: '3', value: 'family' },
  { code: '4', value: 'singleParent' },
  { code: '5', value: 'childrenOnly' },
  { code: '6', value: 'familyPlus' },
  { code: '7', value: 'singleParentPlus' },
];

export const CoverCompositionCRMCodes = Object.freeze({
  SINGLE: 'single',
  COUPLE: 'couple',
  FAMILY: 'family',
  SINGLE_PARENT: 'singleParent',
  CHILDREN_ONLY: 'childrenOnly',
  FAMILY_PLUS: 'familyPlus',
  SINGLE_PARENT_PLUS: 'singleParentPlus',
});
